import { getLogiUser } from '../../ui/utils';
import useSWR from 'swr';
export function useLogiUser() {
    return useSWR(['/composer/api/user'], getLogiUser, {
        revalidateOnFocus: false,
    });
}
